<template>
  <v-dialog v-model="show" persistent max-width="500px">
    <v-card>
      <v-toolbar color="primaryLight" dark dense>
        <v-toolbar-title>{{ accionDialog }}</v-toolbar-title>
      </v-toolbar>

      <v-card-text>
        <v-form ref="form" v-model="isValid">
          <v-container>
            <v-row>
              <v-col>
                <v-text-field v-model="nombre" label="Dispositivo" :rules="[globalRules.required]" outlined dense />
              </v-col>
              <v-col>
                <v-select
                  v-model="tipoSelected"
                  label="Proveedor"
                  :items="proveedores"
                  item-text="NOMBRE"
                  item-value="ID_GEO_PROVEEDOR"
                  return-object
                  outlined
                  dense
                />
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn text color="red" @click="cancelar">Cancelar</v-btn>
        <v-btn text color="green" :disabled="!isValid" @click="aceptar">Aceptar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import constants from '@/helpers/constants'
import DateService, { FMT } from '@/helpers/DateService'

export default {
  props: {
    show: Boolean,
    isEdit: Boolean,
    editedDispositivo: Object
  },

  data: () => ({
    isValid: false,

    nombre: null,

    fechaCreacion: null,

    tipoSelected: null,
    mediosSelected: []
  }),

  computed: {
    ...mapGetters('medio', [
      'medios'
    ]),
    ...mapGetters('dispositivo', [
      'dispositivos'
    ]),
    ...mapGetters('proveedor', [
      'proveedores'
    ]),
    accionDialog () {
      return this.isEdit ? 'Editar' : 'Nuevo'
    },
    fechaCreacionFormatted () {
      const date = this.$date.parseDate(this.fechaCreacion)
      return date.isValid() ? this.$date.formatDate(date, FMT.onlyDate) : ''
    }
  },

  watch: {
    show () {
      if (this.show && this.isEdit && this.editedDispositivo) {
        this.nombre = this.editedDispositivo.DISPOSITIVO

        if (this.proveedores.length && this.editedDispositivo.PROVEEDOR) {
          this.tipoSelected = this.proveedores.find(p =>
            p.NOMBRE === this.editedDispositivo.PROVEEDOR
          )
        }

        if (this.medios.length && this.editedDispositivo.MEDIO) {
          this.mediosSelected = this.medios.find(m =>
            m.MEDIO === this.editedDispositivo.MEDIO
          )
        }
      } else {
        this.resetForm()
      }
    }

  },

  methods: {
    ...mapActions('dispositivo', ['fetchDispositivos']),
    aceptar () {
      const nombreExistente = this.dispositivos.some(d =>
        d.CODIGO_EXTERNO?.toLowerCase() === this.nombre?.toLowerCase() &&
        (!this.isEdit || d.ID_GEO_DISPOSITIVO !== this.editedDispositivo?.ID_GEO_DISPOSITIVO)
      )

      if (nombreExistente) {
        this.$notify({ text: 'Ya existe un dispositivo con ese nombre', color: 'red' })
        return
      }

      const nuevoDispositivo = {
        CODIGO_EXTERNO: this.nombre,
        ID_GEO_PROVEEDOR: this.tipoSelected?.ID_GEO_PROVEEDOR
      }

      if (this.isEdit) {
        nuevoDispositivo.ID_GEO_DISPOSITIVO = this.editedDispositivo.ID_GEO_DISPOSITIVO
        this.$emit('editDispositivo', {
          ...nuevoDispositivo,
          ID_MEDIO: this.mediosSelected?.ID_MEDIO
        })
      } else {
        this.$emit('addDispositivo', {
          ...nuevoDispositivo,
          ID_MEDIO: this.mediosSelected?.ID_MEDIO
        })
      }

      this.$refs.form.reset()
      this.$emit('update:show', false)
    },

    cancelar () {
      this.$refs.form.reset()
      this.$emit('cancelar')
      this.$emit('update:show', false)
    },

    resetForm () {
      this.nombre = null
      this.tipoSelected = null
      this.mediosSelected = []
      this.$refs.form?.reset()
    }
  },
  mounted () {
    try {
      this.fetchDispositivos()
    } catch (error) {
      console.error('Error al cargar los dispositivos:', error)
      this.$notify?.({ text: 'Error al cargar los dispositivos', color: 'red' })
    }
  }
}

</script>

<style scoped>
</style>
